import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import bus from './assets/js/event-bus'

const JBH:any = require('./assets/js/JsBridgeHandlers.js');
const analyticSelf = require('./assets/js/analytic-self-pro').default;

Vue.config.productionTip = false
Vue.prototype.$JBH = JBH.default;
Vue.prototype.$as = analyticSelf.$as;
Vue.prototype.$bus = bus;

const Toasted = require('vue-toasted').default;
const options = {
  className: "my_toast",
  theme: "toasted-primary", 
  position: "top-center", 
  singleton: true,
  duration : 5000
};
Vue.use(Toasted, options);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
